export default "__VITE_ASSET__BbgIDrdU__"